import api from "../api"
export default {
	async getNisForm(resubmit = false) {
		let value = await api.get(`/nisforms/2026`, {
			params: resubmit ? { Resubmit: 1 } : {},
		})
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async submitForm(nisID, answers, answernumbers) {
		let value = await api.post(`/nisassessments`, {
			answers: answers,
			nisID: nisID,
			answernumbers: answernumbers
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async saveSubmission(nisID, answers, answernumbers) {
		let value = await api.put(`/nisdrafts/${nisID}`, {
			answers: answers,
			nisID: nisID,
			answernumbers: answernumbers
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getNisAssessment(id) {
		let value = await api.get(`nisassessments/${id}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
	async getNisAssessmentsAll() {
		let value = await api.get(`nisassessmentsall/`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
	async getNisSuppliers() {
		let value = await api.get(`/nissuppliers`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
	async getSuppliersWithoutNis() {
		let value = await api.get(`/nisinvite`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
	async sendInvitation(recipientIDs) {
		let value = await api.post(`/nisinvite`, { recipients: recipientIDs })
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
}
